import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.css';
import './styles/headfoot404.css';
import './css/main.css';
import './styles/doctree.css';
import './styles/static/staticsupport.css';
import App from './App';


ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

